import { Component, Input, OnInit } from "@angular/core";
import { PolicyService } from "src/app/modules/policy/policy.service";
import { IFormKey } from "src/app/modules/shared/models/forms";
import { CommonUtils } from "src/app/utils/CommonUtils";
import { premium_payment_form_group_config } from "./premium-payment-suspension.constants";
import { FormGroup } from "@angular/forms";

@Component({
    selector: 'app-premium-payment-suspension',
    templateUrl: './premium-payment-suspension.component.html',
    styleUrl: './premium-payment-suspension.component.scss',
})
export class PremiumPaymentSuspensionComponent implements OnInit {
  @Input({ required: true }) form: FormGroup;

  public keys: IFormKey[];

  constructor(private _policyService: PolicyService) {}

  ngOnInit(): void {
    if (this.isPolicyPrevidenziale){
      this.keys = CommonUtils.assign(premium_payment_form_group_config)
    }
  }

  get isPolicyPrevidenziale(): boolean {
    return this._policyService.isDetailPrevidenziale;
  }
}
